import { Button } from "styled";
import Model from "components/Modal";
import { deleteDocumentById } from "apis/customApiHandler";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { saveErrorCreationEvent } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";

const Delete = ({ data, handleClick }) => {
  const queryClient = useQueryClient();
  const location = useLocation();

  function vehicleDeleteEventFunc(eventName, params) {
    return saveErrorCreationEvent(eventName, "Delete Vehicle", "Vehicles", location.pathname, params);
  }

  const handleClickDelete = async (id) => {
    vehicleDeleteEventFunc(ANALYTICS_EVENTS.CLICK_DELETE_CHANGES, { deleted_vehicle_id: id });
    try {
      const apiResponse = await deleteDocumentById("vehicle", id);
      if (apiResponse) {
        vehicleDeleteEventFunc(ANALYTICS_EVENTS.SYS_DELETE_VEHICLE_SUCCESS, { deleted_vehicle_id: id });
        toast.success("Successfully deleted");
        queryClient.invalidateQueries("vehicles");
      }
      handleClick();
    } catch (error) {
      const errMsg = error?.response?.data?.message || error?.message;
      vehicleDeleteEventFunc(ANALYTICS_EVENTS.SYS_DELETE_VEHICLE_ERROR, { deleted_vehicle_id: id, errMsg });
    }
  };

  return (
    <Model handleClick={handleClick} title={"Delete Vehicle"} className="max-w-2xl">
      <div className="p-4">
        <p className="text-red-500 p-5 text-center">
          Are you sure you want to delete this Vehicle?
        </p>
        <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            No
          </Button>
          <Button type="button" bgPrimary onClick={() => handleClickDelete(data?._id)}>
            Yes
          </Button>
        </div>
      </div>
    </Model>
  );
};

export default Delete;
